import type { SVGProps } from 'react'
const SolidApple = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={25}
		height={24}
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_26600_25812)">
			<path
				d="M22.125 18.7038C21.762 19.5423 21.3324 20.3141 20.8346 21.0237C20.1561 21.9911 19.6006 22.6607 19.1725 23.0325C18.5088 23.6429 17.7977 23.9555 17.0362 23.9733C16.4896 23.9733 15.8304 23.8177 15.063 23.5022C14.2931 23.1881 13.5855 23.0325 12.9386 23.0325C12.2601 23.0325 11.5324 23.1881 10.7541 23.5022C9.97454 23.8177 9.34656 23.9821 8.86643 23.9984C8.13623 24.0295 7.4084 23.7081 6.68191 23.0325C6.21822 22.6281 5.63824 21.9348 4.94344 20.9526C4.19799 19.9037 3.58512 18.6875 3.10498 17.3009C2.59078 15.8031 2.33301 14.3528 2.33301 12.9487C2.33301 11.3403 2.68055 9.95308 3.37668 8.7906C3.92377 7.85685 4.6516 7.12028 5.56253 6.57955C6.47347 6.03883 7.45773 5.76328 8.5177 5.74565C9.09768 5.74565 9.85825 5.92505 10.8034 6.27764C11.7459 6.6314 12.3511 6.8108 12.6164 6.8108C12.8147 6.8108 13.487 6.60103 14.6267 6.18282C15.7044 5.79498 16.614 5.6344 17.3592 5.69765C19.3784 5.86061 20.8954 6.65659 21.9042 8.09062C20.0984 9.18481 19.2051 10.7174 19.2228 12.6834C19.2391 14.2147 19.7947 15.4891 20.8865 16.5009C21.3813 16.9705 21.9339 17.3335 22.5487 17.5912C22.4153 17.9779 22.2746 18.3482 22.125 18.7038ZM17.494 0.480625C17.494 1.6809 17.0555 2.80159 16.1815 3.83889C15.1267 5.07204 13.8509 5.78461 12.4674 5.67217C12.4497 5.52818 12.4395 5.37663 12.4395 5.21737C12.4395 4.06511 12.9411 2.83196 13.8319 1.8237C14.2766 1.31319 14.8422 0.888716 15.5281 0.550104C16.2126 0.216543 16.86 0.0320773 17.4688 0.000488281C17.4866 0.160946 17.494 0.321414 17.494 0.48061V0.480625Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_26600_25812">
				<rect
					width="24"
					height="24"
					fill="white"
					transform="translate(0.333008)"
				/>
			</clipPath>
		</defs>
	</svg>
)
export { SolidApple }
